import { ApiServiceBase } from './apiServiceBase';

export class NotePackageService extends ApiServiceBase {
    private apiUrl = '/api/notepackages/1.0';

    exportNotes(name: string, noteIds: string[], onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.postJson(`${this.apiUrl}`, onSuccess, onFailure, {
            Name: name,
            NoteIds: noteIds
        });
    }

    emailExportedNotes(id: string, to: string[], onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.postJson(`${this.apiUrl}/share`, onSuccess, onFailure, {
            id: id,
            to: to
        });
    }

    importNotes(share: string, key: number, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(`${this.apiUrl}/import/?share=${share}&key=${key}`, onSuccess, onFailure);
    }
}